/**
 * Body scroll lock shared by the consent dialogs.
 *
 * The consent modal and the preferences dialog can hand over to each other, so
 * the lock is reference counted: the page only scrolls again once the last
 * dialog has released it.
 */
let locks = 0
let previousOverflow = null

export function lockScroll () {
  if (typeof document === 'undefined') {
    return
  }

  if (locks === 0) {
    previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
  }

  locks++
}

export function unlockScroll () {
  if (typeof document === 'undefined' || locks === 0) {
    return
  }

  locks--

  if (locks === 0) {
    document.body.style.overflow = previousOverflow || ''
    previousOverflow = null
  }
}
